export const CropStarLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17 23V19H7C6.45 19 5.97933 18.8043 5.588 18.413C5.19667 18.0217 5.00067 17.5507 5 17V7H1V5H5V1H7V17H23V19H19V23H17ZM17 15V7H9V5H17C17.55 5 18.021 5.196 18.413 5.588C18.805 5.98 19.0007 6.45067 19 7V15H17Z"
        fill="url(#paint0_linear_7806_19555)"
      />
      <path
        d="M9.90921 15.3L10.5079 12.7119L8.5 10.9711L11.1526 10.7408L12.1842 8.30005L13.2158 10.7408L15.8684 10.9711L13.8605 12.7119L14.4592 15.3L12.1842 13.9277L9.90921 15.3Z"
        fill="url(#paint1_linear_7806_19555)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7806_19555"
          x1="12"
          y1="1"
          x2="12"
          y2="23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1FC38F" />
          <stop offset="1" stopColor="#1FC38F" stopOpacity="0.7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7806_19555"
          x1="12.1842"
          y1="8.30005"
          x2="12.1842"
          y2="15.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1FC38F" />
          <stop offset="1" stopColor="#1FC38F" stopOpacity="0.7" />
        </linearGradient>
      </defs>
    </svg>
  )
}
